export default {
  nav: {
    features: 'Features',
    howItWorks: 'How it works',
    download: 'Download'
  },
  hint: {
    openInBrowser: 'Open in Browser'
  },
  hero: {
    headlinePrefix: 'RECORD WHAT',
    headlineSuffix: 'HAPPENS',
    subheadline: 'Professional Stats • Automated Insights • Winning Strategy',
    startNow: 'Start Now',
    getApp: 'Get The App',
    explore: 'Explore',
    learnMore: 'Learn More'
  },
  features: {
    titlePrefix: 'Smart',
    titleSuffix: 'Recording',
    item1: {
      title: 'Event-Driven Logic',
      desc: 'Record actions, not just numbers. Input "Shot Made", and we handle points, assists, and percentages automatically.'
    },
    item2: {
      title: 'Intelligent Prompts',
      desc: 'Missed a shot? The app instantly prompts for the rebound. Steal? It asks who lost the ball. Never miss a detail.'
    },
    item3: {
      title: 'Visual Shot Charts',
      desc: 'Track shot locations with precision. Generate professional heatmaps and efficiency reports for every player.'
    }
  },
  workflow: {
    titlePrefix: 'Workflow',
    titleSuffix: 'Simplified',
    step1: {
      title: 'Quick Setup',
      desc: 'Create teams and add players in seconds. Configure match rules to fit your league perfectly.'
    },
    step2: {
      title: 'Live Tracking',
      desc: 'Tap to log events. Our intuitive interface handles complex scenarios like fouls and substitutions seamlessly.'
    },
    step3: {
      title: 'Instant Insights',
      desc: 'Get real-time Box Scores and post-game reports. Export detailed images to share with your team.'
    }
  },
  download: {
    titlePrefix: 'Ready to',
    titleSuffix: 'Start?',
    desc: 'Join thousands of coaches and players using StatPoint to elevate their game.',
    button: 'Download App',
    learnMore: 'Learn More'
  }
}
